import React from 'react';
import { Text } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  name: string;
}

const AddedClientList = ({
  name,
  children,
}: React.PropsWithChildren<Props>) => {
  const isEmpty = React.Children.count(children) === 0;

  return (
    <Styled.Wrapper>
      <Text variant="md-semibold" marginBottom={24}>
        {name} 받아볼 고객
      </Text>
      <Styled.StackAddedClientsWrapper
        gap={8}
        wrap="wrap"
        className={isEmpty ? 'empty' : ''}
      >
        {isEmpty ? (
          <Styled.EmptyText
            as="p"
            variant="md-medium"
            color="zinc_400"
            textAlign="center"
          >
            이곳에 추가된 고객 한 분마다
            <br />
            반응 파악용 링크가 생성됩니다.
          </Styled.EmptyText>
        ) : (
          children
        )}
      </Styled.StackAddedClientsWrapper>
    </Styled.Wrapper>
  );
};

export default AddedClientList;
